import { useInfiniteQuery } from "@tanstack/react-query";
import { notificationKeys } from "../../queryKeys";
import {
  getNotification,
  NotificationQueryParams,
} from "../../api/notification.api";

export const useNotification = (params: NotificationQueryParams) => {
  return useInfiniteQuery({
    queryKey: [...notificationKeys.all, { limit: params.limit }],
    queryFn: ({ pageParam }) =>
      getNotification({
        ...params,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),

    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage?.cursor?.SK ?? undefined,
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
